var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectCategoryTechnology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 36993"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4027",
    x: 0.35,
    y: 0.35,
    width: 21.3,
    height: 14.3,
    rx: 1.65,
    stroke: "currentColor",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4028",
    x: 1.35,
    y: 1.35,
    width: 19.3,
    height: 11.3,
    rx: 1.65,
    stroke: "currentColor",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 102",
    d: "M8.5 15V16.2C8.5 16.3657 8.36569 16.5 8.2 16.5H5.68541C5.57178 16.5 5.4679 16.5642 5.41708 16.6658L5.21708 17.0658C5.11735 17.2653 5.2624 17.5 5.48541 17.5H16.5146C16.7376 17.5 16.8827 17.2653 16.7829 17.0658L16.5829 16.6658C16.5321 16.5642 16.4282 16.5 16.3146 16.5H13.8C13.6343 16.5 13.5 16.3657 13.5 16.2V15",
    stroke: "currentColor",
    strokeWidth: 0.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectCategoryTechnology);
export default __webpack_public_path__ + "static/media/project-category-technology.7e829d5c.svg";
export { ForwardRef as ReactComponent };